/**
 * A class describing activity of users.
 */
export class UserActivity {
  date: string;
  userId: string;

  /**
   * @param date the date on which the user was active.
   * @param userId the identifier of the user.
   */
  constructor(date: string, userId: string) {
    this.date = date;
    this.userId = userId;
  }
}
